export default "__VITE_ASSET__D_4sa1Ff__"